const PhraseInContextEditorPostProcessor = process.browser
  ? require('i18next-phrase-in-context-editor-post-processor').default
  : require('i18next-phrase-in-context-editor-post-processor');

const nextLocales = process.env.NEXT_PUBLIC_LOCALES_AVAILABLE.split(",");

module.exports = {
  i18n: {
    defaultLocale: "fr",
    fallbackLng: nextLocales,
    locales: nextLocales,
    ignoreRoutes: ["/_next/", "/locales/"],
    localePath: typeof window === "undefined" ? `public/locales/${process.env.NEXT_PUBLIC_CUSTOMER}` : `locales/${process.env.NEXT_PUBLIC_CUSTOMER}`,
    reloadOnPrerender: true,
  },
  serializeConfig: false,
  use: [
    new PhraseInContextEditorPostProcessor({
      phraseEnabled: process.env.NEXT_PUBLIC_PHRASE_ENABLED === "true",
      projectId: process.env.NEXT_PUBLIC_PHRASE_PROJECT_ID || "",
      accountId: process.env.NEXT_PUBLIC_PHRASE_ACCOUNT_ID || "",
    }),
  ],
  postProcess: ['phraseInContextEditor'],
};
